import React from "react";
import type { UseFormSetValue } from "react-hook-form";
import type { AddCostFormValues, PlanningMonth } from "../../CostPanel.types";
import { monthCellWriteOptions } from "./monthCellWrite";

const useCopyAcrossMonths = (
  planningMonths: PlanningMonth[],
  setValue: UseFormSetValue<AddCostFormValues>,
): ((variableId: string, januaryValue: string) => void) => {
  return React.useCallback(
    (variableId: string, januaryValue: string) => {
      for (const month of planningMonths.slice(1)) {
        setValue(
          `${variableId}.${month.key}`,
          januaryValue,
          monthCellWriteOptions,
        );
      }
    },
    [planningMonths, setValue],
  );
};

export default useCopyAcrossMonths;
